"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.ACTION_BTN_MOBILE = exports.ACTION_CONTENT = exports.PAGE_HEADER = void 0;

var _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../../../common/styles/vars"),
    PAGE_HEADER = function PAGE_HEADER(a) {
  var b = a.darkMode;
  return (0, _cxs["default"])({
    background: b ? _vars.COLOURS.grey.codGrey : _vars.COLOURS.mono.white,
    color: b ? _vars.COLOURS.mono.white : _vars.COLOURS.mono.black,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "50px",
    height: "100px",
    " > *": {
      ":first-child": {
        flex: 1
      }
    }
  });
};

exports.PAGE_HEADER = PAGE_HEADER;
var ACTION_CONTENT = (0, _cxs["default"])({
  display: "flex",
  alignItems: "center"
});
exports.ACTION_CONTENT = ACTION_CONTENT;
var ACTION_BTN_MOBILE = (0, _cxs["default"])({
  width: "50px"
});
exports.ACTION_BTN_MOBILE = ACTION_BTN_MOBILE;